import type { FC } from 'react';

import classNames from 'classnames';

import type { AriaProps } from '@iconik-io/shared-lib/src/react/a11y/aria';

import RadioButton from './radiobutton';

import styles from './radiobuttons.module.css';

type Props = {
  name: string;
  value?: string;
  options: Record<string, string>[];
  onChange?: (value: string) => void;
  column?: boolean;
  disabled?: boolean;
  className?: string;
  radioButtonClassName?: string;
  aria?: AriaProps;
};

const RadioButtons: FC<Props> = ({
  options,
  name,
  value,
  onChange,
  column,
  disabled,
  className,
  radioButtonClassName,
  aria,
}) => (
  <div
    className={classNames(
      styles.root,
      {
        [styles.column]: column,
      },
      className,
    )}
    role="radiogroup"
  >
    {options.map((option) => (
      <div key={`${name}_${option.value}`} className={radioButtonClassName}>
        <RadioButton
          name={name}
          value={option.value}
          checked={option.value === value}
          disabled={disabled}
          onChange={(event) => {
            if (onChange) {
              onChange(event.target.value);
            }
          }}
          label={option.label}
          aria={{
            ...aria,
            label: aria?.label ? `${aria.label} ${option.label}` : undefined,
          }}
        />
      </div>
    ))}
  </div>
);

export default RadioButtons;
